/* @flow */

import React, { Component } from 'react';
import withSideEffect from 'react-side-effect';


class NestedStatus extends Component {
  static displayName: 'NestedStatus';

  props: {
    code: number,
    children: React.Element,
  };

  render() {
    if (this.props.children) {
      return this.props.children;
    } else {
      return null;
    }
  }
}

function handleStateChangeOnClient() {}

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.code;
  }
  return 200;
}

export default withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient,
)(NestedStatus);



// WEBPACK FOOTER //
// ../src/client/components/NestedStatus.js